import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import GameConfig from "../model/GameConfig";
import Navigation from "../model/Navigation";

export default class GateKeeperOverlayMediator extends AbstractPopupMediator {

    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {somajs.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {GameConfig} gameConfig 
     */
    constructor(target, dispatcher, languagePack, layoutManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager);
        this._gameConfig = gameConfig;
    }


    initialize() {
        super.initialize();

        const bg = this._target.bg;
        //block clicks through panel, quick and dirty
        bg.addEventListener("click", () => { });
        
        const prefix = "gatekeeper.";
        this._buttonBack = this.createButton(this._target.button1, this._handleBack.bind(this), this.getText(prefix + "buttonBack"));
        this._buttonStart = this.createButton(this._target.button2, this._handleStart.bind(this), this.getText(prefix + "buttonStart"));

        this._target.bodyTextfield.text = this.getText(prefix + "body");
        this._target.titleTextfield.text = this.getText(prefix + "title");
    }


    _handleBack() {
        this._close(Navigation.BACK);
    }
    
    _handleStart() {
        this._close(Navigation.OK);
    }

    _close(payload) {
        this._buttonBack.setEnabled(false);
        this._buttonStart.setEnabled(false);
        this.close(payload);
    }
};